"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

class Element extends HTMLElement {

    constructor() {
        super();

        this.root = this.attachShadow({ mode: "open" });

        const content = baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.container = this.shadowRoot.querySelector('.swiftref-filter-tags');

        this.removeTags = function (event) {
            const target = event.target;
            const payload = {
                filter_name: target.getAttribute("data-filter-name"),
                filter_value: target.getAttribute("data-filter-value"),
            }
            this.dispatchEvent(new CustomEvent("remove-filter", {
                detail: payload,
                bubbles: true
                // composed: true
            }));
            this.container.removeChild(target);
        }.bind(this);


    }


    static get observedAttributes() {
        return ["filters", "filters_labels"];
    }

    get filters() {
        try {
            return JSON.parse(this.getAttribute("filters"));
        } catch (e) {
            return {};
        }
    }
    set filters(value) {
        this.setAttribute("filters", JSON.stringify(value));
    }
    get filters_labels() {
        try {
            return JSON.parse(this.getAttribute("filters_labels"));
        } catch (e) {
            return {};
        }
    }
    set filters_labels(value) {
        this.setAttribute("filters_labels", JSON.stringify(value));
    }


    attributeChangedCallback(name, oldValue, newValue) {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(this.render.bind(this), 1);
    }


    connectedCallback() {
        this.container.addEventListener("remove", this.removeTags);
    }

    disconnectedCallback() {
        this.container.removeEventListener("remove", this.removeTags);
    }

    render () {
        const filters = this.filters;
        const filtersLabels = this.filters_labels || {};

        // clear any previous tags
        this.container.innerText = '';

        for (const filter in filters) {
            const badge = document.createElement("swiftref-badge");
            badge.innerText = filtersLabels.hasOwnProperty(filter) ? `${filtersLabels[filter]}: ${filters[filter]}` : `${filters[filter]}`;
            badge.setAttribute("state", "info");
            /**
             * If the tags are disabled, do not show the x button to remove them
             *
             * @author Simone Sacchi
             * @version 2025/09/29
             */
            if (!this.disabled || (Array.isArray(this.disabled) && this.disabled.indexOf(filter) === -1)) {
                badge.setAttribute("clear_icon", "");
            }
            badge.setAttribute("data-filter-name", filter);
            badge.setAttribute("data-filter-value", filters[filter]);
            this.container.appendChild(badge);
        }

    }

}

window.customElements.define("swiftref-filter-tags", Element);

module.exports = Element;
